module.exports = __webpack_public_path__ + "img/top-bar-background.f62ca53a.svg";